module.exports = __webpack_public_path__ + "bd.81d919dd9dae5b8ab51e.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bd.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bd.svg
// module chunks = styles